import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/betstride/images/logo-footer.png';

export default function index() {
  return <Image src={footerLogo} maxW="160px" maxH="50px" />;
}
